import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/react';
import { injectIntl } from 'react-intl-next';
import { ACTION, ACTION_SUBJECT, ACTION_SUBJECT_ID, EVENT_TYPE } from '@atlaskit/editor-common/analytics';
import { textColorMessages as messages } from '@atlaskit/editor-common/messages';
import { expandIconWrapperStyle, separatorStyles, triggerWrapperStyles, wrapperStyle } from '@atlaskit/editor-common/styles';
import { ColorPalette, getSelectedRowAndColumnFromPalette, textPaletteTooltipMessages } from '@atlaskit/editor-common/ui-color';
import { ArrowKeyNavigationType, DropdownContainer as Dropdown, TOOLBAR_BUTTON, ToolbarButton } from '@atlaskit/editor-common/ui-menu';
import { hexToEditorTextPaletteColor } from '@atlaskit/editor-palette';
import { akEditorMenuZIndex } from '@atlaskit/editor-shared-styles';
import ExpandIcon from '@atlaskit/icon/glyph/chevron-down';
import { changeColor as changeColorWithAnalytics } from '../../commands/change-color';
import { EditorTextColorIcon } from './icon';
import { backgroundDisabled, textColorIconBar, textColorIconWrapper } from './styles';
var EXPERIMENT_NAME = 'editor.toolbarTextColor.moreColors';
var EXPERIMENT_GROUP_CONTROL = 'control';
// eslint-disable-next-line @repo/internal/react/no-class-components
export var ToolbarTextColor = /*#__PURE__*/function (_React$Component) {
  _inherits(ToolbarTextColor, _React$Component);
  var _super = _createSuper(ToolbarTextColor);
  function ToolbarTextColor() {
    var _this;
    _classCallCheck(this, ToolbarTextColor);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      isOpen: false,
      isOpenedByKeyboard: false
    });
    _defineProperty(_assertThisInitialized(_this), "toolbarItemRef", /*#__PURE__*/React.createRef());
    _defineProperty(_assertThisInitialized(_this), "changeColor", function (color, editorAnalyticsApi) {
      return changeColorWithAnalytics(color, editorAnalyticsApi)(_this.props.editorView.state, _this.props.editorView.dispatch);
    });
    _defineProperty(_assertThisInitialized(_this), "changeTextColor", function (color, editorAnalyticsApi, disabled) {
      if (!disabled) {
        var _this$props$editorVie;
        var palette = _this.props.pluginState.palette;

        // we store color names in analytics
        var swatch = palette.find(function (sw) {
          return sw.value === color;
        });
        _this.dispatchAnalyticsEvent(_this.buildAnalyticsSelectColor({
          color: (swatch ? swatch.label : color).toLowerCase()
        }));
        _this.handleOpenChange({
          isOpen: false,
          logCloseEvent: false
        });
        _this.changeColor(color, editorAnalyticsApi);
        //To set the focus on the textcolor button when the menu is closed by 'Esc' only to meet aria guidelines
        (_this$props$editorVie = _this.props.editorView) === null || _this$props$editorVie === void 0 || _this$props$editorVie.focus();
      }
      return false;
    });
    _defineProperty(_assertThisInitialized(_this), "toggleOpen", function () {
      _this.handleOpenChange({
        isOpen: !_this.state.isOpen,
        logCloseEvent: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        _this.setState({
          isOpenedByKeyboard: true
        });
        _this.toggleOpen();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleOpenChange", function (_ref) {
      var isOpen = _ref.isOpen,
        logCloseEvent = _ref.logCloseEvent,
        event = _ref.event;
      _this.setState({
        isOpen: isOpen
      });
      if (!isOpen) {
        _this.setState({
          isOpenedByKeyboard: false
        });
      }
      if (logCloseEvent) {
        _this.dispatchAnalyticsEvent(_this.buildAnalyticsPalette(isOpen ? ACTION.OPENED : ACTION.CLOSED, {
          noSelect: isOpen === false
        }));
      }
      if (!isOpen && event instanceof KeyboardEvent && (event === null || event === void 0 ? void 0 : event.key) === 'Escape') {
        var _this$toolbarItemRef;
        (_this$toolbarItemRef = _this.toolbarItemRef) === null || _this$toolbarItemRef === void 0 || (_this$toolbarItemRef = _this$toolbarItemRef.current) === null || _this$toolbarItemRef === void 0 || _this$toolbarItemRef.focus();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "hide", function (e) {
      var isOpen = _this.state.isOpen;
      if (isOpen === true) {
        _this.dispatchAnalyticsEvent(_this.buildAnalyticsPalette(ACTION.CLOSED, {
          noSelect: true
        }));
        _this.setState({
          isOpen: false
        });
        if (e instanceof KeyboardEvent && e.key === 'Escape') {
          var _this$toolbarItemRef2;
          (_this$toolbarItemRef2 = _this.toolbarItemRef) === null || _this$toolbarItemRef2 === void 0 || (_this$toolbarItemRef2 = _this$toolbarItemRef2.current) === null || _this$toolbarItemRef2 === void 0 || _this$toolbarItemRef2.focus();
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "hideonEsc", function (e) {
      var _this$toolbarItemRef3;
      _this.hide(e);
      (_this$toolbarItemRef3 = _this.toolbarItemRef) === null || _this$toolbarItemRef3 === void 0 || (_this$toolbarItemRef3 = _this$toolbarItemRef3.current) === null || _this$toolbarItemRef3 === void 0 || _this$toolbarItemRef3.focus();
    });
    return _this;
  }
  _createClass(ToolbarTextColor, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        isOpen = _this$state.isOpen,
        isOpenedByKeyboard = _this$state.isOpenedByKeyboard;
      var _this$props = this.props,
        popupsMountPoint = _this$props.popupsMountPoint,
        popupsBoundariesElement = _this$props.popupsBoundariesElement,
        popupsScrollableElement = _this$props.popupsScrollableElement,
        isReducedSpacing = _this$props.isReducedSpacing,
        pluginState = _this$props.pluginState,
        formatMessage = _this$props.intl.formatMessage,
        disabled = _this$props.disabled,
        pluginInjectionApi = _this$props.pluginInjectionApi;
      var labelTextColor = formatMessage(messages.textColor);
      var palette = pluginState.palette;
      var fitWidth;
      if (document.body.clientWidth <= 740) {
        // This was originally hard-coded, but moved here to a const
        // My guess is it's based off (width of button * columns) + left/right padding
        // 240 = (32 * 7) + (8 + 8)
        // Not sure where the extra 2px comes from
        fitWidth = 242;
      }
      var selectedColor = this.getSelectedColor(pluginState);
      var _getSelectedRowAndCol = getSelectedRowAndColumnFromPalette(palette, pluginState.color),
        selectedRowIndex = _getSelectedRowAndCol.selectedRowIndex,
        selectedColumnIndex = _getSelectedRowAndCol.selectedColumnIndex;
      return (
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        jsx("span", {
          css: wrapperStyle
        }, jsx(Dropdown, {
          mountTo: popupsMountPoint,
          boundariesElement: popupsBoundariesElement,
          scrollableElement: popupsScrollableElement,
          isOpen: isOpen && !pluginState.disabled,
          handleClickOutside: this.hide,
          handleEscapeKeydown: this.hideonEsc,
          zIndex: akEditorMenuZIndex,
          fitWidth: fitWidth,
          closeOnTab: true,
          arrowKeyNavigationProviderOptions: {
            type: ArrowKeyNavigationType.COLOR,
            selectedRowIndex: selectedRowIndex,
            selectedColumnIndex: selectedColumnIndex,
            isOpenedByKeyboard: isOpenedByKeyboard,
            isPopupPositioned: true
          },
          trigger: jsx(ToolbarButton, {
            buttonId: TOOLBAR_BUTTON.TEXT_COLOR,
            spacing: isReducedSpacing ? 'none' : 'default',
            disabled: disabled || pluginState.disabled,
            selected: isOpen,
            "aria-label": labelTextColor,
            "aria-expanded": isOpen,
            "aria-haspopup": true,
            title: labelTextColor,
            onClick: this.toggleOpen,
            onKeyDown: this.onKeyDown,
            ref: this.toolbarItemRef,
            iconBefore:
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            jsx("div", {
              css: triggerWrapperStyles
            }, jsx("div", {
              css: textColorIconWrapper
            }, jsx(EditorTextColorIcon, null), jsx("div", {
              css: [
              // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
              textColorIconBar, selectedColor ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
              "background: ".concat(selectedColor, ";") :
              // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
              pluginState.disabled && backgroundDisabled]
            })), jsx("span", {
              css: expandIconWrapperStyle
            }, jsx(ExpandIcon, {
              label: ""
            })))
          })
        }, jsx("div", {
          "data-testid": "text-color-palette"
        }, jsx(ColorPalette, {
          onClick: function onClick(color) {
            var _pluginInjectionApi$a;
            return _this2.changeTextColor(color, pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a === void 0 ? void 0 : _pluginInjectionApi$a.actions, pluginState.disabled);
          },
          selectedColor: pluginState.color,
          paletteOptions: {
            palette: palette,
            hexToPaletteColor: hexToEditorTextPaletteColor,
            paletteColorTooltipMessages: textPaletteTooltipMessages
          }
        }))), jsx("span", {
          css: separatorStyles
        }))
      );
    }
  }, {
    key: "getSelectedColor",
    value: function getSelectedColor(pluginState) {
      var selectedColor = pluginState.color !== pluginState.defaultColor && (pluginState.color ? hexToEditorTextPaletteColor(pluginState.color) : pluginState.color);
      return selectedColor;
    }
  }, {
    key: "getCommonAnalyticsAttributes",
    value: function getCommonAnalyticsAttributes() {
      return {
        experiment: EXPERIMENT_NAME,
        experimentGroup: EXPERIMENT_GROUP_CONTROL
      };
    }
  }, {
    key: "buildAnalyticsPalette",
    value: function buildAnalyticsPalette(action, data) {
      return {
        action: action,
        actionSubject: ACTION_SUBJECT.TOOLBAR,
        actionSubjectId: ACTION_SUBJECT_ID.FORMAT_COLOR,
        eventType: EVENT_TYPE.TRACK,
        attributes: _objectSpread(_objectSpread({}, this.getCommonAnalyticsAttributes()), data)
      };
    }
  }, {
    key: "buildAnalyticsSelectColor",
    value: function buildAnalyticsSelectColor(data) {
      return {
        action: ACTION.FORMATTED,
        actionSubject: ACTION_SUBJECT.TEXT,
        actionSubjectId: ACTION_SUBJECT_ID.FORMAT_COLOR,
        eventType: EVENT_TYPE.TRACK,
        attributes: _objectSpread(_objectSpread({}, this.getCommonAnalyticsAttributes()), data)
      };
    }
  }, {
    key: "dispatchAnalyticsEvent",
    value: function dispatchAnalyticsEvent(payload) {
      var dispatchAnalyticsEvent = this.props.dispatchAnalyticsEvent;
      if (dispatchAnalyticsEvent) {
        dispatchAnalyticsEvent(payload);
      }
    }
  }]);
  return ToolbarTextColor;
}(React.Component);
export default injectIntl(ToolbarTextColor);